import React from 'react';
import {
  CANCEL_EXTENSION,
  DELETE_EXTENSION,
  EXTENSION_DELETE_CONFIRMATION_TITLE,
  SURE_DELETE_EXTENSION_RESPONSIVE,
} from '@app/constants/texts';
import {
  Box,
  Button,
  IconButton,
  Icons,
  Modal,
  Tooltip,
  Typography,
} from '@ublend-npm/aulaui-core';

type Props = {
  styles: any;
  showLoader: boolean;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteExtensionModal = ({
  styles,
  showLoader,
  open,
  onClose,
  onConfirm,
}: Props) => {
  return (
    <Modal open={open} onClose={showLoader ? undefined : onClose}>
      <Box sx={styles.modal}>
        <Box sx={styles.header}>
          <Typography sx={styles.title} id="delete-extension" tabIndex={0}>
            {EXTENSION_DELETE_CONFIRMATION_TITLE}
          </Typography>
          <IconButton
            aria-label="Close delete extension dialog"
            onClick={onClose}
            sx={styles.closeButton}
            disabled={showLoader}
          >
            <Tooltip title="Close">
              <Icons.Close />
            </Tooltip>
          </IconButton>
        </Box>

        <Typography component="div" sx={styles.body} tabIndex={0}>
          {SURE_DELETE_EXTENSION_RESPONSIVE}{' '}
        </Typography>

        <Box sx={styles.footer}>
          <Button
            kind="secondary"
            type="button"
            sx={styles.buttonSx}
            onClick={onClose}
            disabled={showLoader}
          >
            {CANCEL_EXTENSION}
          </Button>
          <Button
            kind="primary"
            type="button"
            sx={styles.buttonSx}
            onClick={onConfirm}
            disabled={showLoader}
            loading={showLoader}
          >
            {DELETE_EXTENSION}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteExtensionModal;
